module.exports = __webpack_public_path__ + "img/africas-leading-online-travel-agency-2017-winner-shield-64.bf784bb6.png";